import { getUserInfo , logOut} from '@/api/user'
import { getFindByCodeInfo } from '@/api/publishOnline'
import { findToken } from '@/api/login'
import { removeUserToken,getUserToken,setUserToken } from '@/utils/cookies'
import {getzaBranchfindByToken} from '@/api/read-instance'

const user = {
  state: {
    token: '',
    userInfo: '',
    host: process.env.READ_PLATFORM_PATH,
    isLogin: false,
    isBranchLogin:false,//是否是机构用户
    userBranchInfo:''//机构用户信息
  },
  mutations: {
    set_token: (state, token) => {
      state.token = token
    },
    set_userInfo: (state, userInfo) => {
      state.userInfo = userInfo
    },
    set_isLogin: (state, isLogin) => {
      state.isLogin = isLogin
    },
    set_userBranchInfo: (state, userBranchInfo) => {
      state.userBranchInfo = userBranchInfo
    },
    set_isBranchLogin: (state, isBranchLogin) => {
      state.isBranchLogin = isBranchLogin
    },
    set_productInfo: (state, isProductInfo) => {
      state.isProductInfo = isProductInfo
    }
  },
  actions: {
    // 获取商品信息
    getFindByCodeInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getFindByCodeInfo().then(response => {
          const data = response.data
          let errorInfo = data.errorInfo
          if (errorInfo === 'success') {
            commit('isProductInfo', data.data)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          let errorInfo = data.errorInfo
          if (errorInfo === 'success') {
            commit('set_userInfo', data.data)
            commit('set_isLogin', true)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //判断是否是机构用户
    getUserBranchInfo ({commit,state}) {
      return new Promise((resolve, reject) => {
        getzaBranchfindByToken().then(res => {
          if (res.errorInfo === 'success'&&res.data !=null) {
            console.log('res1423456',res);
            commit('set_userBranchInfo', res.data)
            commit('set_isBranchLogin', true)
          }
            resolve(res)
          
        }).catch(error => {
          reject(error)
        })
      })
    },
    findToken ({ commit }) {
      // alert(1)
      return new Promise((resolve, reject) => {
        // alert(2)
        // if(getUserToken()){
        //   return ;
        // }

        findToken().then(response => {
          const token = response.data.data
          commit('SET_TOKEN', token)
          setUserToken(token)
          resolve(response)
        }).catch(error => {
          // alert(5)
          console.log('error0',error)
          reject(error)
        })
      })
    },
    // 登出用户
    loginOut ({ commit }) {
      return new Promist((resolve, reject) => {
        logout().then((response) => {
          commit('set_token', '')
          commit('set_userInfo', '')
          commit('set_isLogin', false)
          removeUserToken()
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js